<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Input Group" pageTitle="Input Group" />
            <InputGroup />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import InputGroup from '../InputGroup/InputGroup'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'FormEditorPage',
    components: {
        MainHeader,
        PageTitle,
        InputGroup,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>